import { ISMapPolygon } from '@summit/maps';
import { EPosition } from '@summit/models';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { State } from '../state/state';
import { LocationSource } from './location-source.enum';
import { LocationType } from './location-type.enum';

//this should be a name TO object, but loading issue
export class ELocation extends EboNameObject implements ISMapPolygon {
  type: LocationType;
  source: LocationSource;
  stateId: string;
  state: State;
  geometry: EPosition[];

  constructor(jsonData?: Partial<ELocation>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.state) {
        this.state = new State(jsonData.state);
      }
      if (jsonData.geometry) {
        this.geometry = jsonData.geometry.map((data) => new EPosition(data));
      }
    }
  }

  addBoundary(rawBoundaries: number[][][]) {
    const lclBoundary = [];
    rawBoundaries
      .sort((a, b) => a.length - b.length) //putting most complex first
      .forEach((dataArray) => {
        //console.log('Adding location based on:', dataArray);
        const newLocation = new ELocation({
          //stateId: this.id,
          name: this.name,
          source: LocationSource.USCensus,
          type: LocationType.State,
          geometry: Array.isArray(dataArray)
            ? dataArray.map((data) => new EPosition({ longitude: data[0], latitude: data[1] }))
            : []
        });
        lclBoundary.push(newLocation);
      });
    if (lclBoundary.length > 1) console.warn('Multiple boundaries found for:', this.name, lclBoundary);
    this.geometry = lclBoundary.length > 0 ? lclBoundary[0].boundary : null;
    if (this.geometry == null || this.geometry.length === 0) {
      console.warn('No boundary found for:', this.name, rawBoundaries);
    }
  }
}
